export const E_CATALOGUE_ROOT_ELEMENT_ID = 'catalogue-ipaper-root';

export const isECatalogue = () => Boolean(document.getElementById(E_CATALOGUE_ROOT_ELEMENT_ID));
